import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { CircleNotch } from "@phosphor-icons/react";

export const ProtectedRoute = ({ children }) => {
  const { user, loading, pinLocked } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        data-testid="auth-loading"
        className="min-h-screen flex flex-col items-center justify-center gap-3 bg-background"
      >
        <CircleNotch size={28} className="animate-spin text-primary" weight="bold" />
        <p className="text-sm text-muted-foreground">Checking your secure access…</p>
      </div>
    );
  }

  if (!user) {
    if (pinLocked) {
      return <Navigate to="/unlock" replace />;
    }
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
};
